<template>
  <div v-if="visible.length" class="page-open-banners">
    <div v-for="banner in visible" :key="banner.id" class="alert alert-success page-open-banner" role="status">
      <span>{{ banner.message }}</span>
      <button type="button" class="btn btn-sm btn-outline-dark" @click="dismiss(banner.id)">Dismiss</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageOpenBanners',
  props: {
    banners: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {

    return {
      dismissed: {}
    }
  },
  computed: {
    visible () {

      return (this.banners || []).filter(banner => banner && banner.message && !this.dismissed[banner.id])
    }
  },
  methods: {
    dismiss (id) {

      this.dismissed = Object.assign({}, this.dismissed, { [id]: true })
    }
  }
}
</script>

<style scoped>
.page-open-banners {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0;
  text-align: left;
}
.page-open-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0;
}
</style>
